import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Validations } from 'src/app/shared-resources/constants/validations.constant';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorHandlerService, MessageType } from 'src/app/shared-resources/services/http-error-handling.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';


@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.less']
})
export class VerifyOtpComponent implements OnInit {
  public validateForm: FormGroup;
  public passwordVisible = false;
  public password: string;
  staticOtp: number;
  public customRoles = [];
  public loading = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private httpMessage: HttpErrorHandlerService,
    private userInfoService: UserInfoService
  ) {}


  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }

  goto(): void {
    this.staticOtp = 889545
    this.loading = true;
    if (this.validateForm.valid) {
      if(this.staticOtp === parseInt(this.validateForm.get('opt')?.value)) {
        sessionStorage.setItem('isOTPVerified','true');
        this.router.navigateByUrl('/app/landing');
      } else {
        sessionStorage.setItem('isOTPVerified','false');
        this.httpMessage.showTopFloatMessage(
          this.translate.instant('app.label.otp-user-allowed'),
          MessageType.ERROR,
          this.translate.instant('app.label.unauthorised')
        );
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
  }

  ngOnInit(): void {
    const token = this.userInfoService.getUserToken();
    if (!token) {
      this.router.navigateByUrl('/login');
    }
    this.validateForm = this.fb.group({
      opt: [null,[Validators.required, Validators.maxLength(6), Validators.minLength(6), Validators.pattern(Validations.REGEX_INTEGER)]]
    });
 }

}

